// Functions relating to the Payment UI

/*****************************************************************************************************************************

	this is pretty confusing - there are 2 of these - payment.js and paymentSingleProduct.js - which one is applied is set by 
	the definition or otherwise of globals.isSingleProductPage which is defined in script in the buy but not topup blade
	 
*/

$(function()
{
	var discountApplied=false;
	var discountAbsOrPercent=0;
	var discountType='flat';
	
	var iCurrencyUnit='&pound;'
	var iPayAnnually=($('#is_annual').val()=="1");
//console.log(iPayAnnually);

	// show a warning if password and confirmation don't match
	$('#password').on('blur',function(e){
		if (document.getElementById('password_confirmation').value.length>0)
			showWarningOnPasswordMismatch();
	});
	
	$('#password_confirmation').on('blur',function(e){
		showWarningOnPasswordMismatch();
	});

	function showWarningOnPasswordMismatch()
	{
		if (document.getElementById('password').value==document.getElementById('password_confirmation').value)
			$('#passwords_mismatch_warning').hide();		
		else
			$('#passwords_mismatch_warning').show();
	}
		
    if (globals.isSingleProductPage!==true)
		return;

	$('.product-selector').on('change', function(e){
		updateForm();
	});

	$('#vat_jurisdiction').on('change', function(e){
		updateForm();
	});

	// Do we have a query string?
	var bundleId=getParameterByName('plan');
	if (bundleId!==null)
	{
		$('#plan').val(bundleId);
	}

	$('#discount_code').on('change', function(e){
		e.preventDefault();
		var discount_code=$('#discount_code').val();
		verify_discount_code(discount_code);
	});
	
	$('#pay_monthly_annual_toggle').on('click', function(e) {toggleMonthlyAnnual(); return false;} );

	updateForm();

	function toggleMonthlyAnnual()
	{
		iPayAnnually=!iPayAnnually;
		
		// change the button text
		$('#monthly_annual_pseudo_button_text').text(iPayAnnually? "monthly" : "annual");	// the opposite of what it currently is - this is the toggle switch text
		
		// hide/show the relevant lines in the invoice
		$(iPayAnnually ? '#annual_payment_lines' : '#monthly_payment_lines').show();
		$(iPayAnnually ? '#monthly_payment_lines' : '#annual_payment_lines').hide();
		
		// set the hidden control value
		$('#is_annual').val(iPayAnnually ? 1 : 0);

		updateForm();
	}
	
	function verify_discount_code(discount_code)
	{
		var uri='/discount/verify?code='+discount_code;
		var jqxhr=$.get(
				uri,
				function(data){
					if (data!==false)
					{
						apply_discount_code(data);
					}
					else
					{
						$('#discount_code').val('');
						$('#discountCodeMessage').addClass('error').html(
								'Sorry that code is not valid.');
					}
				}).fail(
				function(){
					$('#discount_code').val('');
					$('#discountCodeMessage').addClass('error').html(
							'Sorry that code is not valid.');
				});
	}

	function apply_discount_code(code)
	{
		if (discountApplied===false)
		{
			discountType=code.type;
			discountAbsOrPercent=code.discount;
			discountApplied=true;
			$('#discount_applied').show(0);
			updateForm();
		}
	}

	function getParameterByName(name)
	{
		url=window.location.href;
		name=name.replace(/[\[\]]/g, "\\$&");
		var regex=new RegExp("[?&]"+name+"(=([^&#]*)|&|#|$)"),results=regex
				.exec(url);
		if (!results)
			return null;
		if (!results[2])
			return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	function updateForm()
	{
		// NB globals.products is defined in <script> tags in indexBuyStandard.blade.php like this {!! $products->toJson() !!};
		var productId=$('#plan').val();
		var product=(productId!=null ? ($.grep(globals.products,function(e){return e.id==productId;}))[0] : null);
//console.log(product);

		// Note - all currency values are in pence and converted to pounds for display

		var label='No plan selected';
		var credits=0;

		var setUpFee=0;
		var preTaxTotal=monthlyFee=upfrontAnnualPayment=upfrontAnnualPaymentTotal=0;

//console.log(globals.annualUpfrontMonthlyMultiplier);
		
		if (product!=null)
		{
			label=product.name;
			credits=product.credits;
			setUpFee=product.setup_fee;
			if (setUpFee==0)
				preTaxTotal=product.price;
			else
			{
				monthlyFee=(iPayAnnually ? product.annual_monthly_fee : product.monthly_fee);
				if (globals.use_annual_monthly_price_structure)
					upfrontAnnualPayment=monthlyFee*12;					
				else
					upfrontAnnualPayment=monthlyFee*globals.annualUpfrontMonthlyMultiplier;
				upfrontAnnualPaymentTotal=product.setup_fee+upfrontAnnualPayment;
				preTaxTotal=product.setup_fee+(iPayAnnually ? upfrontAnnualPayment : product.monthly_fee);
			}			
		}

		var totalBeforeDiscount=0;
		var discount=0;
		var discountString='0%';

		var tax=0;
		var total=0;

		// Get the VAT rate
		var jurisdiction_id=$('#vat_jurisdiction').val();

		// NB globals.vatRates is defined in <script> tags in indexBuyStandard.blade.php like this {!! $vatRates->toJson() !!};
		var vatRateMatches=$.grep(globals.vatRates, function(e){return e.jurisdiction_id==jurisdiction_id;}); // find the country rate
		var vatRatePercent=(vatRateMatches.length>0 ? vatRateMatches[0].rate : 0);

		totalBeforeDiscount=(iPayAnnually ? upfrontAnnualPaymentTotal : preTaxTotal);
//alert(totalBeforeDiscount);
		// discount code
		if (discountType=='flat')
		{
			discountString='&pound;'+discountAbsOrPercent;
			discount=discountAbsOrPercent;
		}
		else if (discountType=='percentage')
		{
			discountString=discountAbsOrPercent+'%';
			discount=totalBeforeDiscount*(discountAbsOrPercent/100);
		}
		
		if (discount<0)
			discount=0;

		// Total it up
		totalBeforeDiscount=totalBeforeDiscount-discount;
		tax=totalBeforeDiscount*vatRatePercent/100;
		total=totalBeforeDiscount+tax;

		// Set the fields
		$('.sale_item_description').html(label);
//		$('.bundleCredits').html(credits);
		$('.sale_item_setup_fee').html(currencyFormat(setUpFee));
		$('.sale_item_monthly_price').html(currencyFormat(monthlyFee));
		$('.sale_item_pre_tax_total').html(currencyFormat(preTaxTotal));
		$('.sale_item_total_upfront_price').html(currencyFormat(upfrontAnnualPayment));

		$('.total_discount').html(currencyFormat(discount));
		$('#discountRate').html(discountString);
		// discount currently not visible in page
		// $('.totalBeforeDiscount').html(currencyFormat(totalBeforeDiscount));

		$('.taxRate').html(vatRatePercent);
		$('.taxAmount').html(currencyFormat(tax));
		$('.total').html(currencyFormat(total));
	}

	function currencyFormat(aAmountMinorUnits,a){
		return iCurrencyUnit+(aAmountMinorUnits/100).toFixed(2);
	}
});
